import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

const config = {
    apiKey: "AIzaSyDNXkviXT1Z4RsfYPa3CFOWSbgEl7uuxaE",
    authDomain: "hackathon-1f4cc.firebaseapp.com",
    projectId: "hackathon-1f4cc",
    storageBucket: "hackathon-1f4cc.appspot.com",
    messagingSenderId: "322192457924",
    appId: "1:322192457924:web:155226cbe236d4b3558991",
    measurementId: "G-8TYYJL0NY4"
};

const firebaseApp = firebase.initializeApp(config);
firebase.analytics();

const timestamp = firebase.firestore.FieldValue.serverTimestamp;

// const db = firebase.firestore()
// const auth = firebase.auth()
// const currentUser = auth.currentUser
// const functions = firebase.app().functions('europe-west1')

export {timestamp}
export default firebaseApp.firestore()
